// Week 33 AI Tutor Format (Real Data)
export default {
  weekId: 33,
  title: "Corridor Safety & School Care",
  title_vi: "An Toàn Hành Lang & Chăm Sóc Trường Học",
  story_missions: [
    { id: 1, title: "Mission 1: Corridor Incident", prompt_en: "Retell what happened when a student slipped in the corridor.", prompt_vi: "Kể lại điều xảy ra khi một học sinh bị trượt chân trong hành lang." },
    { id: 2, title: "Mission 2: First Aid Care", prompt_en: "Explain how the school nurse applied first aid.", prompt_vi: "Giải thích cách y tá trường học thực hiện sơ cứu." },
    { id: 3, title: "Mission 3: Personal Safety Action", prompt_en: "Describe a safety rule you follow at school.", prompt_vi: "Mô tả một quy tắc an toàn em tuân thủ ở trường." }
  ],
  spark_talk: [
    { id: 1, title: "Card 1: Why walk carefully?", prompt_en: "Why should students walk carefully in school corridors?", prompt_vi: "Tại sao học sinh nên đi lại cẩn thận trong hành lang trường học?" },
    { id: 2, title: "Card 2: Helping injured friends", prompt_en: "How can you help a classmate who gets hurt?", prompt_vi: "Làm thế nào em có thể giúp một bạn học bị thương?" }
  ],
  target_vocab: [
    "corridor", "slipped", "nurse", "bandage", "relieved",
    "mistake", "accident", "fix", "sorry", "careful",
    "clumsy", "arm", "knee", "leg", "head",
    "cold pack", "recover", "explain", "lesson", "terrible"
  ],
  sentences: [
    { id: 1, text: "Jake was walking carefully down the corridor.", vi: "Jake đang đi bộ cẩn thận xuống hành lang." },
    { id: 2, text: "A boy running fast slipped on the wet floor.", vi: "Một cậu bé chạy nhanh bị trượt chân trên sàn nhà ướt." },
    { id: 3, text: "Jake called the school nurse immediately.", vi: "Jake đã gọi y tế nhà trường ngay lập tức." },
    { id: 4, text: "The nurse treated the cut with a clean bandage.", vi: "Cô y tá đã điều trị vết cắt bằng một chiếc băng cá nhân sạch." },
    { id: 5, text: "Everyone felt relieved and praised Jake for safety.", vi: "Mọi người đều cảm thấy nhẹ nhõm và khen ngợi Jake vì đã giữ an toàn." }
  ]
};
